<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
// Add click-to-copy functionality to all coupon codes
  const couponCodes = document.querySelectorAll('.coupon-code');
  couponCodes.forEach(couponCode => {
    couponCode.addEventListener('click', () => {
      // Copy the coupon code to clipboard
      navigator.clipboard.writeText(couponCode.textContent.trim());

      // Show a tooltip indicating that the code was copied
      const tooltip = document.createElement('span');
      tooltip.classList.add('tooltiptext');
      tooltip.textContent = 'Copied!';
      couponCode.appendChild(tooltip);

      // Remove the tooltip after a few seconds
      setTimeout(() => {
        tooltip.remove();
      }, 2000);
    });
  });